// @flow
import {CCHToAEMLocaleMap} from '../constants/appsConstants';

export function getAEMPath(sapcode: string, locale: string) {
	const loc = CCHToAEMLocaleMap[locale];
	switch (sapcode.toLowerCase().trim()) {
		case 'gethelpconfig':
			return `/content/dam/ccsurfaces/getHelp/${loc}/experienceHelpMenu/help-menu--all-apps-app-picker-.cfm.gql.json`;
		case 'gethelpconfigcampaign':
			return `/content/dam/ccsurfaces/getHelp/${loc}/experienceHelpMenu/help-menu--email-deep-linking-.cfm.gql.json`;
		case 'gethelpconfigccpp':
			return `/content/dam/ccsurfaces/getHelp/${loc}/experienceHelpMenu/help-menu--ccpp-app-picker-.cfm.gql.json`;
		case 'gethelpconfigccppn':
			return `/content/dam/ccsurfaces/getHelp/${loc}/experienceHelpMenu/help-menu--ccppn-app-picker-.cfm.gql.json`;
		case 'gethelpconfigsubstancecollection':
			return `/content/dam/ccsurfaces/getHelp/${loc}/experienceHelpMenu/help-menu-substance-3d-collection-app-picker.cfm.gql.json`;
		case 'gethelpconfigsubstancetexturing':
			return `/content/dam/ccsurfaces/getHelp/${loc}/experienceHelpMenu/Help-Menu-Substance-3D-Texturing-App-Picker.cfm.gql.json`;
		case 'gethelpconfigsingleapp':
			return `/content/dam/ccsurfaces/getHelp/${loc}/experienceHelpMenu/help-menu--single-app-plan-.cfm.gql.json`;
		case 'getapppickerconfig':
			return `/content/dam/ccsurfaces/appPicker/${loc}/experienceAppPicker/all-apps-app-picker.cfm.gql.json`;
		case 'getapppickerconfigccpp':
			return `/content/dam/ccsurfaces/appPicker/${loc}/experienceAppPicker/ccpp-app-picker.cfm.gql.json`;
		case 'getapppickerconfigccppn':
			return `/content/dam/ccsurfaces/appPicker/${loc}/experienceAppPicker/ccppn-app-picker.cfm.gql.json`;
		case 'getapppickerconfigsubstancetexturing':
			return `/content/dam/ccsurfaces/appPicker/${loc}/experienceAppPicker/substance-3D-Texturing-App-Picker.cfm.gql.json`;
		case 'getapppickerconfigsubstancecollection':
			return `/content/dam/ccsurfaces/appPicker/${loc}/experienceAppPicker/substance-3d-collection-app-picker.cfm.gql.json`;
		case 'getapppickerconfig-illustrator':
			return `/content/dam/ccsurfaces/appPicker/${loc}/experienceAppPicker/illustrator-single-app-plan.cfm.gql.json`;
		case 'getapppickerconfig-xd':
			return `/content/dam/ccsurfaces/appPicker/${loc}/experienceAppPicker/xd-single-app-plan.cfm.gql.json`;
		case 'getapppickerconfig-incopy':
			return `/content/dam/ccsurfaces/appPicker/${loc}/experienceAppPicker/incopy-single-app-plan.cfm.gql.json`;
		case 'getapppickerconfig-audition':
			return `/content/dam/ccsurfaces/appPicker/${loc}/experienceAppPicker/audition-single-app-plan.cfm.gql.json`;
		case 'getapppickerconfig-dimension':
			return `/content/dam/ccsurfaces/appPicker/${loc}/experienceAppPicker/dimension-single-app-plan.cfm.gql.json`;
		case 'getapppickerconfig-dreamweaver':
			return `/content/dam/ccsurfaces/appPicker/${loc}/experienceAppPicker/dreamweaver-single-app-plan.cfm.gql.json`;
		case 'getapppickerconfig-animate':
			return `/content/dam/ccsurfaces/appPicker/${loc}/experienceAppPicker/animate-single-app-plan.cfm.gql.json`;
		case 'getapppickerconfig-lightroom':
			return `/content/dam/ccsurfaces/appPicker/${loc}/experienceAppPicker/lightroom-single-app-plan.cfm.gql.json`;
		case 'getapppickerconfig-aftereffects':
			return `/content/dam/ccsurfaces/appPicker/${loc}/experienceAppPicker/after-effects-single-app-plan.cfm.gql.json`;
		case 'getapppickerconfig-indesign':
			return `/content/dam/ccsurfaces/appPicker/${loc}/experienceAppPicker/indesign-single-app-plan.cfm.gql.json`;
		case 'getapppickerconfig-premiere-rush':
			return `/content/dam/ccsurfaces/appPicker/${loc}/experienceAppPicker/premiere-rush-single-app-plan.cfm.gql.json`;
		case 'getapppickerconfig-premiere':
			return `/content/dam/ccsurfaces/appPicker/${loc}/experienceAppPicker/premiere-pro-single-app-plan.cfm.gql.json`;
		case 'getapppickerconfig-acrobat':
			return `/content/dam/ccsurfaces/appPicker/${loc}/experienceAppPicker/acrobat-single-app-plan.cfm.gql.json`;
		case 'getapppickerconfig-photoshop':
			return `/content/dam/ccsurfaces/appPicker/${loc}/experienceAppPicker/photoshop-single-app-plan.cfm.gql.json`;
		case 'skeletonwithstock':
			return `/content/dam/ccsurfaces/AppSkeleton/${loc}/experienceAppsSkeleton/CCWeb-Skeleton-with-Adobe-Stock.cfm.gql.json`;
		case 'allappbanners':
			return `/content/dam/ccsurfaces/LCMgrowth/${loc}/experienceAllAppsBanners/default-banners-for-all-apps-june-2020.cfm.gql.json`;
		case 'videocardsinfoilst':
			return `/content/dam/ccsurfaces/deepLinkingCampaignPage/${loc}/emailLandingPage/Illustrator.cfm.gql.json`;
		case 'videocardsinfophsp':
			return `/content/dam/ccsurfaces/deepLinkingCampaignPage/${loc}/emailLandingPage/Photoshop.cfm.gql.json`;
		case sapcode.toLowerCase().trim():
			return `/content/dam/ccsurfaces/AppCatalog/${loc}/appsPDP/${sapcode}.cfm.gql.json`;
		default:
			return '';
	}
}
